import { connectWebComponents }      from 'fg-frontend/src/webComponents/decorate';
import configureWebComponents from './configureWebComponents';
import 'fg-frontend/ramjet/liveValidation';


connectWebComponents(configureWebComponents);



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureWeb.js